module.exports = __webpack_public_path__ + "static/media/2XL.9e8b6d74.jpg";